<template>
  <MemberSettingsChangeCardModal v-model:open="modalOpen" />
  <MemberSettingsViewProductModal v-model:open="modalOpen2" />
  <MemberSettingsDeleteAccountModal v-model:open="modalOpen3" />
  <main class="py-10 px-4 sm:px-6 lg:px-8">
    <header class="border-b border-gray-300">
      <!-- Secondary navigation -->
      <nav class="flex overflow-x-auto py-4">
        <ul
          role="list"
          class="flex min-w-full flex-none gap-x-6 px-4 text-sm font-semibold leading-6 text-gray-400 sm:px-6 lg:px-8"
        >
        <li v-for="item in secondaryNavigation" :key="item.name">
            <!-- Use router-link for navigation -->
            <router-link
              :to="item.to"
              :class="item.current ? 'text-[#2d8bffce]' : ''"
              class="hover:text-[#2d8bffce]"
            >
              {{ item.name }}
            </router-link>
          </li>
        </ul>
      </nav>
    </header>

    <!-- billing content -->
    <div class="divide-y divide-white/5">
      <div
        class="xl:flex justify-between max-w-[900px] mt-10 px-4 sm:px-6 lg:px-8 gap-5"
      >
        <div
          class="h-[200px] w-[430px] border-gray-300 border rounded-lg shadow-sm px-3 py-3"
        >
          <div>
            <h2 class="text-base font-semibold leading-7 text-gray-900">
              Membership Plan
            </h2>
            <p class="mt-1 text-sm leading-6 text-gray-400">
              Community Membership (monthly)
            </p>

            <!-- active badge -->

            <span
              class="inline-flex items-center gap-x-1.5 rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-700"
            >
              <svg
                class="h-1.5 w-1.5 fill-green-500"
                viewBox="0 0 6 6"
                aria-hidden="true"
              >
                <circle cx="3" cy="3" r="3" />
              </svg>
              Active
            </span>

            <!-- cancelling badge -->

            <!-- <span class="inline-flex items-center gap-x-1.5 rounded-full bg-red-100 px-2 py-1 text-xs font-medium text-red-700">
    <svg class="h-1.5 w-1.5 fill-red-500" viewBox="0 0 6 6" aria-hidden="true">
      <circle cx="3" cy="3" r="3" />
    </svg>
    Cancelling
  </span> -->

            <h2 class="text-base font-semibold leading-7 text-gray-900 mt-5">
              Next Payment
            </h2>
            <p class="mt-1 text-sm leading-6 text-gray-400">
              $20.00 on January 1, 2024
            </p>
          </div>
        </div>

        <div
          class="relative h-[200px] w-[430px] mt-4 xl:mt-0 group left-[-15px]"
        >
          <img
            class="absolute w-[375px] h-[200px] transition-opacity duration-500 ease-in-out group-hover:opacity-30"
            src="@/assets/media/images/member-cc.png"
            alt=""
          />
          <div
            class="absolute left-[57%] top-[60%] transform -translate-x-1/2 text-white flex w-full gap-20"
          >
            <div class="">
              <div class="text-lg font-semibold">{{ cardNumber }}</div>
              <div class="mt-1 flex justify-between items-end w-full">
                <span>{{ cardHolderName }}</span>
                <span class="text-sm">{{ cardExpirationDate }}</span>
              </div>
            </div>
            <div class="group">
              <img
                :src="cardLogo"
                alt="Card Logo"
                class="w-16 opacity-100 group-hover:opacity-50"
              />
            </div>
          </div>
          <!-- desktop change payment button -->
          <button
            @click="openModal"
            class="hidden xl:block absolute top-1/2 left-[47%] transform -translate-x-1/2 -translate-y-1/2 px-3 py-2 text-sm font-semibold text-white shadow bg-[#2d8bffce] hover:bg-[#2d8bff] transition-colors duration-200 opacity-0 group-hover:opacity-100 rounded-md"
          >
            Change Payment Method
          </button>

          <!-- mobile change payment button -->
        </div>
        <button
          @click="openModal"
          class="xl:hidden rounded-md mt-6 bg-[#2d8bffce] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#2d8bff81]"
        >
          Change Payment Method
        </button>
      </div>

      <div class="px-4 sm:px-6 lg:px-8 mt-10">
        <div class="sm:flex sm:items-center">
          <div class="sm:flex-auto">
            <h1 class="text-base font-semibold leading-6 text-gray-900">
              Your Product History
            </h1>
          </div>
        </div>
        <div class="mt-8 flow-root">
          <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div
              class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
            >
              <div
                class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
              >
                <table class="min-w-full divide-y divide-gray-300">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                      >
                        Feature
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Expiry Date
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Actions
                      </th>
                      <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                        <!-- <span class="sr-only">view</span> -->
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200 bg-white">
                    <tr v-for="person in people" :key="person.email">
                      <td
                        class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                      >
                        {{ person.name }}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        {{ person.title }}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        <!-- waiting for payment -->
                        <span
                          class="inline-flex items-center gap-x-1.5 rounded-full bg-yellow-100 px-2 py-1 text-xs font-medium text-yellow-800"
                        >
                          <svg
                            class="h-1.5 w-1.5 fill-yellow-500"
                            viewBox="0 0 6 6"
                            aria-hidden="true"
                          >
                            <circle cx="3" cy="3" r="3" />
                          </svg>
                          Waiting for payment
                        </span>
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        <a
                          @click="openModal2"
                          class="text-[#2d8bffce] hover:text-[#246ec7f6] cursor-pointer"
                          >View<span class="sr-only"></span
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8"
      >
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">
            Delete account
          </h2>
          <p class="mt-1 text-sm leading-6 text-gray-400">
            No longer want to use our service? You can delete your account here.
            This action is not reversible. All information related to this
            account will be deleted permanently.
          </p>
          <form class="flex items-start md:col-span-2 mt-5">
            <button
              type="button"
              @click="openModal3"
              class="rounded-md bottom-0 bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400"
            >
              Yes, delete my account
            </button>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>



<script setup>
import { ref } from 'vue';
import { } from '@headlessui/vue';

import MemberSettingsChangeCardModal from '@/Components/MemberSettingsChangeCardModal.vue';
import MemberSettingsViewProductModal from '@/Components/MemberSettingsViewProductModal.vue';
import MemberSettingsDeleteAccountModal from '@/Components/MemberSettingsDeleteAccountModal.vue';

import { } from '@heroicons/vue/24/outline';
import { } from '@heroicons/vue/20/solid';


const secondaryNavigation = [
{ name: 'Profile', to: '/creator/theme-editor/editor-member-settings', current: true },
  { name: 'Billing', to: '/creator/theme-editor/editor-member-billing', current: false }
];



// purchased features table
const people = [
  {
    name: 'Workout Program',
    title: 'January 1, 2024',
    email: 'lindsay.walton@example.com',
    role: 'Member'
  }
];

// dynamic credit card
let cardNumber = ref('**** **** **** 1234');
let cardHolderName = ref('John Doe');
let cardExpirationDate = ref('12/24');
let cardLogo = ref(new URL('@/assets/media/images/Mastercard-logo.png', import.meta.url).href);


// member change card modal trigger
// ref for the modal open state
const modalOpen = ref(false);

// function to open the modal
const openModal = () => {
  modalOpen.value = true;
};

// member product history view actions modal trigger
// ref for the modal open state
const modalOpen2 = ref(false);

// function to open the modal
const openModal2 = () => {
  modalOpen2.value = true;
};

// member delete my account modal trigger
// ref for the modal open state
const modalOpen3 = ref(false);

// function to open the modal
const openModal3 = () => {
  modalOpen3.value = true;
};
</script>
